<template>
 <!-- <tr v-for="item in props.items" :key="item" style="outline: thin solid rgba(0,0,0,.12)">
            <td class="d-block d-md-table-cell nobordertd" v-for="field in Object.keys(item)">
              {{item[field]}}
            </td>
          </tr> -->
          <div>
              <div class="row-alarma-mobile">
                <v-row >
                    <v-col cols="5" lg="3" style="padding: 12px 0px 0 12px">
                        <span> {{cuenta}}</span>
                    </v-col>
                    <v-col cols="8" lg="4" style="padding: 12px 0 0 0; " class="d-none d-lg-block">
                        <span class="ellipsis"> {{descripcion}} {{cuenta}}</span>
                    </v-col>
                    <v-col cols="7" lg="4" style="padding: 12px 12px 0 0">
                        <span style="float: right"> {{ fecha | moment("YYYY-MM-DD hh:mm:ss")}} </span>
                    </v-col>
                    <v-col cols="10" lg="4" style="padding: 4px 0 5px 12px;" class="d-block d-lg-none">
                        <span class="ellipsis arbol-texto"> {{descripcion}} {{cuenta}} </span>
                    </v-col>
                    <v-col cols="2" lg="1" style="padding: 0 12px 0 0" >
                        <v-icon style="float: right">mdi-clock-outline </v-icon>
                    </v-col>

                </v-row>
            </div>
                <div class="row-alarma">
                    <v-row >
                        <v-col cols="5" md="3" >
                            <span> {{cuenta}} </span>
                        </v-col>
                        <v-col cols="8" md="4" class="d-none d-md-block">
                            <span class=""> {{descripcion}} </span>
                        </v-col>
                        <v-col cols="7" md="4">
                            <span style="float: right"> {{ fecha | moment("YYYY-MM-DD hh:mm:ss") }} </span>
                        </v-col>
                        <v-col cols="10" md="4" class="d-block d-md-none">
                            <span class=""> {{descripcion}} </span>
                        </v-col>
                        <v-col cols="2" md="1">
                            <v-icon style="float: right">mdi-clock-outline </v-icon>
                        </v-col>
                    </v-row> 
                </div>
          </div>
    
</template>


<script>

export default {
    name: 'Alarma',
    props:{
        cuenta: String,
        fecha: String,
        descripcion: String
    },
    data: () => ({
    })
}
</script>

<style scoped>

 .row-alarma{
       display: block;
 }

 .row-alarma-mobile{
       display: none;
 }

@media only screen 
and (min-device-width : 768px) 
and (max-device-width : 1024px){
  .row-alarma{
       display: none;
  }

   .row-alarma-mobile{
       display: block;
 }
}

.ellipsis {
    text-overflow: ellipsis;
    /* Required for text-overflow to do anything */
    white-space: nowrap;
    overflow: hidden;
  }

  .arbol-texto{
    display: inline-block;
    max-width: 100%;
}

</style>